import { createResource, type RouteResource } from '@atlassian/react-resource-router';

type Topic = {
	topicId: string;
	aiDraftArticleGenerationState: string;
	jqlQuery: string;
	numberOfRelatedTickets: string;
	topicName: string;
};
export const servicedeskKnowledgeBaseKbTopicsResource: RouteResource<{
	topics: Topic[];
}> = createResource<{ topics: Topic[] }>({
	type: 'SERVICEDESK_KNOWLEDGE_BASE_KB_TOPICS',
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-knowledge-base-kb-topics", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-kb-topics" */ './fetchKbTopics.tsx'
		),
	maxAge: Infinity,
	isBrowserOnly: true,
});
